<template>
  <div class="tri-manager">
    <b-tabs v-model="tabs.active" @change="loadTabById" ref="tabs">
      <b-tab-item
        :label="contractType.name"
        :id="`tab-${contractType.id}`"
        v-for="contractType in contractTypes"
        :key="contractType.id"
      >
        <tri-manager-tab
          :contract-type="contractType"
          :table-fetch="tableFetch"
          :table-fetch-active="tableFetchActive"
          :table-archive="tableArchive"
          :table-restore="tableRestore"
          :table-columns="tableColumns"
          v-if="isTabLoaded(`tab-${contractType.id}`)"
        />
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { tabsMixin } from "@/mixins/tabsMixin";
import { ContractService } from "@/services/contract.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import TriManagerTab from "@/components/Tri/TriManagerTab";

export default {
  contractService: ContractService,
  props: {
    tableFetch: {
      required: true,
    },
    tableFetchActive: {
      required: true,
    },
    tableArchive: {
      required: true,
    },
    tableRestore: {
      required: true,
    },
    tableColumns: {
      type: Array,
    },
  },
  components: {
    TriManagerTab,
  },
  mixins: [tabsMixin],
  data: () => ({
    contractTypes: [],
  }),
  async mounted() {
    await this.fetchContractTypes();
    this.loadTabById(0);
  },
  methods: {
    async fetchContractTypes() {
      try {
        this.contractTypes = await ContractService.listTypes({
          created_by_firm_id: this.$store.state.Auth.user.firmId,
        }).then((response) => JsonDenormalizer.denormalize(response));
      } catch (err) {
        throw err;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tri/TriManager.vue